import { store } from '@/redux/store';
import { openedDrawerSelector } from '@/redux/drawer/drawer.selectors';
import type { DeprecatedDrawerName, DrawerName } from 'minerva-plugin-api';

/**
 * The return type still allows {@link DeprecatedDrawerName} so that v21 code comparing
 * against those names keeps compiling; minerva never returns one.
 */
export const getOpenedPanel = (): DrawerName | DeprecatedDrawerName | undefined => {
  const { getState } = store;
  const drawerName = openedDrawerSelector(getState());

  return drawerName;
};
